export default __webpack_public_path__ + "static/media/ru-ko.c86be418.svg";